<template>
  <component :is="current" v-bind="$attrs" />
</template>

<script setup>
import { useUiWrapper } from '@/utils/uiWrapper'
import FooterViewOld from './Old/OldMermaidChart.vue'
import NewFooterView from './New/NewMermaidChart.vue'

const current = useUiWrapper(FooterViewOld, NewFooterView)
</script>
